import React from "react";
// import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import AvcilarIntro from "../components/ServiceRegions/İntros/AvcilarIntro";
import DynamicImage from "../components/DynamicImage";


const ArnavutkoyPage = () => {
  return (
    <> 
    <div>
        
      {/* <HeroSlider /> */}
      <DynamicImage />
      {/* <AboutSection/> */}
      <AvcilarIntro/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};
export default ArnavutkoyPage;